import React, {  useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import Spinner from '../../component/spinner';
import history from '../../history';
import Dashboard from '../dashboard/dashboard';
import CreateUser from '../user/createUser';
import RoleList from '../user/role/roleList';
import CreateRole from '../user/role/createRole';
import UserList from '../user/user/userList';

import EditRole from '../user/role/editRole';

import FinanceOrderList from '../finance/financeOrderList';
import FinanceOrderDetails from '../finance/financeOrderDetails';
import ClientList from '../clients/clientList';
import ClientsDetails from '../clients/clientsDetails';
import SupportList from '../support/supportList';
import SupportDetails from '../support/supportDetails';
import ContactResponseList from '../contactResponse/contactResponseList';
import ContactResponseDetails from '../contactResponse/contactResponseDetails';

import ApiList from '../setting/apiList';
import ApiListN from '../setting/ApiListN';

import CodeMList from '../code_management/CodeMList';
import CodeMDetails from '../code_management/CodeMDetails.jsx';
import ReportDetails from '../Report_Management/ReportDetails';
import Report from '../Report_Management/Report';
import CodeCMList from '../code_management/CodeCMList';
import CodeCMDetails from '../code_management/CodeCMDetails';
import ProductList from '../product_management/ProductList';


import AppUserList from '../appUser/appUsers';
import AppUserDetails from '../appUser/appUserDetails';


const Switcher  = ({loader}) => {
  
  const [access, setAccess] = useState(null)  
  useEffect(() => {
    if(!localStorage.getItem("token") ||
    localStorage.getItem("token") === null){
      localStorage.clear();
      history.replace("/login");
    }
    setAccess(JSON.parse(localStorage.getItem('access')))
    // socket
  }, [])
  return ( 
    <>
   
    {loader ? <Spinner /> : null} 
    <switch>
        

        {/* <Redirect form="/" to="/dashboard" /> */}
          <>
            {/* ==Setting== */}
            {/* <Route path="/setting/api" component={ApiList}/> */}
            <Route path="/setting/api" component={ApiListN}/>
          </>
        

          <>
            {/* ==Contact== */}
            <Route path="/contact/responses" component={ContactResponseList}/>
            <Route path="/contact/response-details" component={ContactResponseDetails}/>
            
            
            {/* ==Support== */}
            <Route path="/support/tickets" component={SupportList}/>
            <Route path="/support/ticket-details" component={SupportDetails}/>
          </>
        

          <>
            {/* ==Clients== */}
            <Route path="/clients" component={ClientList}/>
            <Route path="/client/client-details" component={ClientsDetails}/>
           
          </>
        

          
            <>
          {/* ==Finance== */}
          <Route path="/finance" component={FinanceOrderList} />
          <Route path="/finance-details" component={FinanceOrderDetails} />
        </>
         
          <>
            {/* ==Report management== */}
            <Route path="/reports" component={Report}/>
            <Route path="/report-details" component={ReportDetails}/>
          </>
          <>
            {/* ==Product management== */}
            <Route path="/products" component={ProductList}/>
           
          </>

          <>
            {/* ==App User== */}
            <Route path="/appUsers" component={AppUserList}/>
            <Route path="/appUser-details" component={AppUserDetails}/>
          </>
        
          <>
            {/* ==code== */}
            <Route path="/batch" component={CodeMList}/>
            <Route path="/batch-details" component={CodeMDetails}/>
            <Route path="/code" component={CodeCMList}/>
            <Route path="/code-details" component={CodeCMDetails}/>
          </>

          
        

          <>
          </>
      

          <>
            {/* ==Role== */}
            <Route path="/roles" component={RoleList}/>
            <Route path="/create-role" component={CreateRole}/>
            <Route path="/edit-role" component={EditRole}/>

            <Route path="/createUser" component={CreateUser}/>
           
            <Route path="/users" component={UserList}/>
          </>
        
        
          <Route path="/dashboard" component={Dashboard}/>
          <Route path="/" exact component={Dashboard}/>
          
        
        
        
        
        
    </switch>
    </>
 );
  
}
 
const mapStateToProps = (state) => {
    return{
      
      loader: state.loader.loading,
      success: state.message.success,
      error: state.message.error,
      validationError: state.message.validationError,
     
    }
  }
export default connect(mapStateToProps)(Switcher);
